import { Box, MenuItem } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import SearchInput from '../../../components/mini/SearchInput';
import Pagination from '../../../components/mini/Pagination';
import { Link, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../../redux/reducers/titleSlice';
import DotMenu from '../../../components/mini/DotMenu';
import { getSettings } from '../../../controllers/settings/getSettings';
import { setModal, setModalComp } from '../../../redux/reducers/modal/modalSlice';
import { getNotifications } from '../../../controllers/settings/notification/getNotifications';
import moment from 'moment';
import CreateNotification from './Create';
import { setAlertMsg } from '../../../redux/reducers/modal/snackBarSlice';
import { deleteNotification } from '../../../controllers/settings/notification/deleteNotification';


const rows = [
  // {
  //   id: 1, customer: '',bookingDate: null,status: ''
  // }
  {
    id: 1, customer: 'Yona',date: '24th Oct, 2023 8:29AM',
    product: "Flight",
    paymentMethod: 'Card Payment',
    amount: 12412, status: 'Pending'
  }
];
[...Array(10-rows.length)].map((o,i) => rows.push({...rows[0],id:i+3}))




function ActionCol({params,reload,edit}) {
  const [anchorEl, setAnchorEl] = useState();
  const dispatch = useDispatch();

  let date = params.value && moment(params.value).format("DD/MM/YY");

  function handleEdit() {
    edit(params.row);
    setAnchorEl(null);
  }
  async function handleDelete() {
    const res = await deleteNotification(params.id);
    if(res.return) {
      reload()
    } else dispatch(setAlertMsg(['error',res.msg]));
  }
  return (
    <div className='flex justify-between gap-2 w-full relative'>
      <p className="flex-1 overflow-hidden overflow-ellipsis" title={date}>
        {date}
      </p>

      <DotMenu  anchor={anchorEl} setAnchor={setAnchorEl} parentControl={true}>
        {/* <MenuItem onClick={handleRemove}>Remove</MenuItem> */}
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </DotMenu>
    </div>
  )
}

const filterItems = [
  {items:[{id: 0,field: 'status',operator: '',value:''}]},
  {items:[{id: 1,field: 'status', operatorValue: 'is', value: 'paid'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'pending'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'cancelled'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'refund'}]},
];



export default function Index() {
  const [data,setData] = useState([]);
  const {type} = useParams();
  const [loading,setLoading] = useState(false);
  const [filter,setFilter] = useState(filterItems[0]);
  const [paginationModel,setPaginationModel] = useState({pageSize: 25,page: 0})
  const [createOpen,setCreateOpen] = useState(false);
  const [editData,setEditData] = useState();


  const [userType,setUserType] = useState("");
  // const [rowId,setRowId] = useState(null);
  const apiRef = useGridApiRef();
  var [fetchedData,setFetchedData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(type);
    dispatch(setHeaderTitle("Notification"))
    load();
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[userType])
  async function load() {
    setLoading(true);
    let q = {
      
    }
    const res = await getNotifications(new URLSearchParams(q));
    if(res.return) {
      // let data = res.data.map(d => d.fareRules.map(obj => ({for: d['for'] || (d['customUser'].firstName+" "+d['customUser'].lastName),...obj}) )).flat(1);
      // console.log('flatted', data)
      setData(res.data);
      setFetchedData(res.data)
    }
    setLoading(false);
  }

  const columns = [
    {field: 'title',headerName: 'Title',flex: 1,minWidth: 60,
      renderCell: (params) => {
        // if(!params.value)
        // return null;
  
        return (
          <div className='flex justify-between w-full relative'>
            <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
              {params.value}
            </p>
          </div>
        )
      }
    },
    {field: 'body',headerName: 'Body',flex: 2,minWidth: 130,
      renderCell: (params) => {
        // if(!params.value)
        // return null;
  
        return (
          <div className='flex justify-between w-full relative'>
            <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
              {params.value}
            </p>
          </div>
  
        )
      }
    },
    {field: 'createdDate',headerName: 'Created Date',flex: 1,minWidth: 130,
      renderCell: (params) => {
        // if(!params.value)
        // return null;
  
        return (
          <ActionCol reload={load} params={params} edit={handleEdit} />
        )
      }
    },
  ];
  

  function handleEdit(obj) {
    setCreateOpen(true);
    setEditData(obj)
  }

  function handleSearch(val) {
    setData(fetchedData);
    if(val === "") return false;

    val = val.toLowerCase();
    setData(data => data.filter(obj => (
      obj.title.toLowerCase().includes(val) ||
      obj.body.toLowerCase().includes(val) ||
      moment(obj.createdDate).format("DD/MM/YY").toLowerCase().includes(val)
    )))
  }
  
  return (
    <div className='w-full p-4 bg-[#f3f3f3] flex flex-col gap-4'>
      
      <button className='btn2 self-end' onClick={() => setCreateOpen(!createOpen)}>{!createOpen ? "Create Notice":"Close"}</button>
      <div className={`bg-secondary px-6 ${createOpen?'':' hidden '}`}>
        <CreateNotification editData={editData} returnData={() => {setEditData(); setCreateOpen(false); load()}} />
      </div>
      <Box className='bg-secondary px-6'>
        <div className='flex gap-4 justify-between items-center my-3 p-3'>
          <SearchInput className='text-theme1' onChange={handleSearch} />
        </div>

        <DataGrid rows={data} columns={columns} loading={loading} autoHeight hideFooter={false}
          // getRowId={(row) => row.id}
          apiRef={apiRef}
          initialState={{
            sorting: {
              sortModel: [{field: "createdDate",sort: 'desc'}]
            },
          }}
          filterModel={filter}
          onFilterModelChange={(newFilter) => setFilter(newFilter)}
          
          // slots={{pagination: Pagination}}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}

          // onCellEditStart={params => setRowId(params.id)}
          // hideFooterPagination
          checkboxSelection
        />
        <Pagination perPage={10} total={46} apiRef={apiRef} />
      </Box>
    </div>
  )
}
